const { getElements } = window.BAO.Utils

class SizeGuide extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.sizesTable = this?.els?.sizes?.element?.querySelector('table')
    this.bodyMeasurementTable = this?.els?.body?.element?.querySelector('table')

    if (this.hasAttribute('data-option')) {
      this.setDefaultBodyMeasurement()
      this.setDefaultSizeRow()
    }
  }

  setupListeners () {
    super.setupListeners()

    if (this?.externalEls?.open?.exists) {
      this.listeners.add(
        this.externalEls.open.element,
        'click',
        this.onOpenClick.bind(this),
      )
    }

    if (this?.externalEls?.close?.exists) {
      this.listeners.add(
        this.externalEls.close.element,
        'click',
        this.onCloseClick.bind(this),
      )
    }

    getElements('tr', { context: this.sizesTable }).forEach(el =>
      this.listeners.add(el, 'click', this.updateVariant),
    )

    document.addEventListener('click', e => {
      if (!document.body.classList.contains('lyt-Site-sizeGuideOpen')) return

      if (e?.target?.dataset?.sizeGuideExternalEl === 'open') return

      if (e?.target?.closest('size-guide') !== null) return

      if (e?.target?.closest('[data-variant-radios-el="option"]') !== null) {
        return
      }

      this.onCloseClick()
    })

    this.listeners.add(
      document,
      window.BAO.EVENTS.VARIANT.CHANGE,
      this.onVariantChanged.bind(this),
    )
  }

  onOpenClick () {
    document.body.classList.add('lyt-Site-sizeGuideOpen')
  }

  onCloseClick () {
    document.body.classList.remove('lyt-Site-sizeGuideOpen')
  }

  updateVariant (e) {
    if (e?.currentTarget?.rowIndex === 0) return

    const variantTitleStripped = e?.currentTarget
      ?.querySelector('td:last-child')
      ?.textContent?.trim()
      ?.toLowerCase()

    const matchingOption = Array.from(
      document.querySelectorAll('[data-product-options-external-el="option"]'),
    ).find(el => el?.value?.trim()?.toLowerCase() === variantTitleStripped)

    if (matchingOption) {
      matchingOption.click()
    }
  }

  onVariantChanged (e) {
    this.findMatchingColumn(
      e?.detail?.variant?.data?.title,
      this.bodyMeasurementTable,
      'body',
    )

    this.findMatchingRow(e?.detail?.variant?.data?.title, this.sizesTable)
  }

  setDefaultSizeRow () {
    this.findMatchingRow(this.dataset.option, this.sizesTable)
  }

  setDefaultBodyMeasurement () {
    this.findMatchingColumn(
      this.dataset.option,
      this.bodyMeasurementTable,
      'body',
    )
  }

  findMatchingRow (option, table) {
    const variantTitle = option
    const variantTitleStripped = variantTitle.trim().toLowerCase()

    if (!table) return

    const matchingRowIndex = Array.from(table.querySelectorAll('tr')).findIndex(
      k =>
        k
          ?.querySelector('td:last-child')
          ?.textContent?.trim()
          ?.toLowerCase() === variantTitleStripped,
    )

    this.highlightRow(matchingRowIndex, table)
  }

  highlightRow (matchingRowIndex, table) {
    if (table !== null) {
      for (let i = 0; i < table.rows.length; i++) {
        table.rows[i].classList.remove('rte-RichText_TableRow-highlighted')
        if (i === matchingRowIndex) {
          table.rows[i].classList.add('rte-RichText_TableRow-highlighted')
        }
      }
    }
  }

  findMatchingColumn (option, table, placement) {
    const variantTitle = option
    const variantTitleStripped = variantTitle.trim().toLowerCase()

    if (!table) return

    const matchingColumnIndex = Array.from(
      table.querySelectorAll('th'),
    ).findIndex(
      k => k.textContent.trim().toLowerCase() === variantTitleStripped,
    )

    this.showColumn(matchingColumnIndex, table, placement)
  }

  showColumn (matchingColumnIndex, table, placement) {
    if (table !== null) {
      for (let i = 0; i < table.rows.length; i++) {
        for (let j = 0; j < table.rows[i].cells.length; j++) {
          table.rows[i].cells[j].style.display = 'none'
          if (j === matchingColumnIndex) {
            table.rows[i].cells[j].style.display = 'table-cell'
          }
        }
      }

      if (placement === 'body') {
        this.els['body-select'].element.style.display = 'none'
      }
    }
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
